import { accountRouteTree } from "@features/account/routes";
import { aiRouteTree } from "@features/ai/routes";
import { analyticsRouteTree } from "@features/analytics/routes";
import { billingRouteTree } from "@features/billing/routes";
import { catalogRouteTree } from "@features/catalog/routes";
import { communicationRouteTree } from "@features/communication/routes";
import { cmsRouteTree } from "@features/cms/routes";
import { customersRouteTree } from "@features/customers/routes";
import { gettingStartedRouteTree } from "@features/getting-started/routes";
import { integrationsRouteTree } from "@features/integrations/routes";
import { marketingRouteTree } from "@features/marketing/routes";
import { notificationsRouteTree } from "@features/notifications/routes";
import { ordersRouteTree } from "@features/orders/routes";
import { pricingRouteTree } from "@features/pricing/routes";
import { posRouteTree } from "@features/pos/routes";
import { securityRouteTree } from "@features/security/routes";
import { settingsRouteTree } from "@features/settings/routes";
import { shippingRouteTree } from "@features/shipping/routes";
import { taxesRouteTree } from "@features/taxes/routes";
import { themesRouteTree } from "@features/themes/routes";

export const featureRouteTree = [
  ...billingRouteTree,
  ...securityRouteTree,
  ...catalogRouteTree,
  ...communicationRouteTree,
  ...cmsRouteTree,
  ...themesRouteTree,
  ...accountRouteTree,
  ...ordersRouteTree,
  ...posRouteTree,
  ...customersRouteTree,
  ...gettingStartedRouteTree,
  ...marketingRouteTree,
  ...notificationsRouteTree,
  ...pricingRouteTree,
  ...analyticsRouteTree,
  ...settingsRouteTree,
  ...taxesRouteTree,
  ...aiRouteTree,
  ...shippingRouteTree,
  ...integrationsRouteTree,
];
